import { useRef, useState, useEffect } from "react";
import styled from "styled-components";

const CollapseWrapper = styled.div`
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: ${({ expanded, contentHeight }) =>
    expanded ? `${contentHeight}px` : "0"};
  position: relative;
`;

const DotsOverlay = styled.div`
  display: ${({ expanded }) => (expanded ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: transparent;
  font-size: 2rem;
  color: #888;
  font-weight: bold;
`;

export default function Collapse({ isOpened, children }) {
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [children, isOpened]);

  useEffect(() => {
    function handleResize() {
      if (isOpened && contentRef.current) {
        setContentHeight(contentRef.current.scrollHeight);
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpened]);

  return (
    <>
      <CollapseWrapper expanded={isOpened} contentHeight={contentHeight}>
        <div ref={contentRef}>{children}</div>
      </CollapseWrapper>
      <DotsOverlay expanded={isOpened}>...</DotsOverlay>
    </>
  );
}
